import dynamic from 'next/dynamic';
import { TravelAgentProps } from './TravelAgent.types';

export const TravelAgentMGP = dynamic<TravelAgentProps>(() => import('./TravelAgent'));
